import ctaMan from "assets/images/psp/inlineCTA.jpg";
import illustrationSearch from "assets/images/psp/illustration-search.svg";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import FemaleAvatar from "assets/images/psp/femaleavatar.jpg";
import CarStorageImage from "assets/images/psp/car-storage.webp";
import TruckStorageImage from "assets/images/psp/truck-trailer-storage.webp";
import HeaderBackgroundDesktop from "assets/images/psp/hero/vehicle-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/vehicle-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/vehicle-header-tablet.webp";
import { storageCategories } from "pages/PSPPage/utils/getPSPLinks";

const faqs = [
	{
		question: "What size storage unit do I need for my vehicle?",
		answer: "Most cars fit in 10x20 vehicle storage units, while trucks and SUVs need 10x25 or 10x30 spaces. Measure your vehicle's length (including any trailer tongue) and width, then add 2-3 feet for door clearance and maneuvering room."
	},
	{
		question: "How should I prepare my vehicle for storage?",
		answer: "Clean thoroughly inside and out, top off fluids, inflate tires to proper pressure, and fill the gas tank (add stabilizer for storage over 30 days). Disconnect the battery or connect a trickle charger, and use a quality cover to prevent dust and protect the paint."
	},
	{
		question: "Do I need climate-controlled storage for my vehicle?",
		answer: "Climate control isn't essential for all vehicles, but it significantly benefits cars stored long-term or those with leather interiors, sensitive electronics, or classic car status. Garage rental space with climate control prevents rust, protects interiors, and maintains rubber and plastic components in extreme climates."
	},
	{
		question: "Can I access my vehicle anytime?",
		answer: "Access policies vary by facility. Many vehicle storage units offer extended hours or 24/7 access, while others have gate hours. If you need regular access for weekend drives or maintenance, confirm facility access hours before renting."
	},
	{
		question: "Does my vehicle need insurance while in storage?",
		answer: "Yes, most facilities require proof of insurance for stored vehicles, and it's legally required to maintain registration on operable vehicles. Contact your insurance provider about storage coverage options—some offer reduced rates for vehicles not driven regularly, lowering vehicle storage costs."
	}
];

const relatedContentCards = [
	{
		category: "Recreational Storage",
		url: "https://www.storage.com/blog/car-storage-unit-size/",
		date: "July 30, 2025",
		image: "https://www.storage.com/blog/wp-content/uploads/2024/10/car-storage-1-jpg.webp",
		content: "What Size Storage Unit for Your Car? A Comprehensive Guide"
	},
	{
		category: "Recreational Storage",
		url: "https://www.storage.com/blog/the-complete-guide-to-vehicle-storage/",
		date: "July 30, 2025",
		image: CarStorageImage,
		content: "Vehicle Storage: Where and How to Store a Car"
	},
	{
		category: "Recreational Storage",
		url: "https://www.storage.com/blog/cost-of-car-storage/",
		date: "September 8, 2025",
		image: "https://www.storage.com/blog/wp-content/uploads/2024/09/outdoorparking-jpg.webp",
		content:
			"How Much Does Vehicle Storage Cost? Comprehensive Guide with Price Comparisons"
	},
	{
		category: "Self-Storage",
		url: "https://www.storage.com/blog/truck-trailer-storage-guide/",
		date: "July 30, 2025",
		image: TruckStorageImage,
		content:
			"Truck and Trailer Storage Guide 2025: Costs, Options, and Tips for Every Vehicle"
	}
];

const pspLinksContent = {
	title: "More Ways to Store",
	image: illustrationSearch,
	storageTypes: storageCategories.vehicle
};

const reviewsContent = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "My Storage.com representative was very helpful and patient with me, working through to find the best location and price.",
			author: "Jess",
			title: "Very helpful.",
			imageSrc: FemaleAvatar
		},
		{
			body: "Storage.com did an excellent job helping me find a storage facility at a great price. Better than the price that I found.",
			author: "Alison",
			title: "Storage facility",
			imageSrc: AnnAlarcon
		},
		{
			body: "Storage.com found me a spot immediately for half the price I had found in my search. Very courteous representatives.",
			author: "Robert Fulton",
			title: "Excellent!",
			imageSrc: SMurphy
		}
	]
};

const vehicleHerodescription = `
Protect your vehicles and reclaim valuable space with secure vehicle storage units close to home. Secure vehicle storage units provide the protection, accessibility, and peace of mind that driveway parking can't match, with flexible options from covered outdoor spaces to climate-controlled garage rental space for your valuable vehicles.
`;

export const PSPVehicleContent = {
	type: "Vehicle",
	sections: [
		{
			title: "Vehicle Storage hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top Vehicle Storage Units",
						description: vehicleHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Vehicle Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Vehicle Storage Hero Image"
					}
				}
			]
		},
		{
			title: "Vehicle Storage Content",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Benefits of Renting a Vehicle Storage Unit",
						background: "light-blue",
						content: [
							{
								id: "1",
								value: "Vehicle storage facilities serve car collectors, RV owners, business fleets, and anyone who needs secure space for vehicles they're not driving daily. From protecting classic cars to housing work trucks, vehicle storage units provide the security and weather protection that extends vehicle life and maintains resale value."
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "Vehicle Storage Solutions Video",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "The Most Popular Vehicle Storage Solutions Available to You",
						description:
							"There are several vehicle storage options available to you, from enclosed garage rental spaces to [open air parking for RV's](https://www.storage.com/blog/can-i-park-my-rv-in-my-driveway/), cars, trucks, and even commercial vehicles.",
						mediaType: "video",
						mediaUrl: "m5hxxfk6kwg",
						videoTitle:
							"The Most Popular Vehicle Storage Solutions Available to You"
					}
				}
			]
		},
		{
			title: "Vehicle Storage Unit Sizes",
			noPadding: true,
			modules: [
				{
					type: "size-chart",
					props: {
						title: "What Size Vehicle Storage Unit Do I Need?",
						description:
							"Vehicles come in many shapes and sizes, and so do the storage units you can park them in. Here's an overview of vehicle storage unit sizes and what kinds of vehicles they can comfortably store.",
						background: "white",
						storages: [
							{
								title: "5x10",
								numerics: ["50 sq ft", "400 cu ft"],
								bestFor: [
									"Motorcycles",
									"Scooters",
									"Dirt bikes"
								]
							},
							{
								title: "10x10",
								numerics: ["100 sq ft", "800 cu ft"],
								bestFor: [
									"Motorcycles",
									"Compact ATVs",
									"Dirt bikes"
								]
							},
							{
								title: "10x15",
								numerics: ["150 sq ft", "1,200 cu ft"],
								bestFor: [
									"Sedans (Civics, Corollas)",
									"Car supplies",
									"Spare tires"
								]
							},
							{
								title: "10x20",
								numerics: ["200 sq ft", "1,600 cu ft"],
								bestFor: [
									"Mid-sized vehicles (Accords, Camrys)",
									"Crossovers",
									"Car care supplies"
								]
							},
							{
								title: "10x25",
								numerics: ["250 sq ft", "2,000 cu ft"],
								bestFor: [
									"Pick up trucks with extended beds",
									"Large SUVs"
								]
							},
							{
								title: "10x30",
								numerics: ["300 sq ft", "2,400 cu ft"],
								bestFor: [
									"Commercial vehicle storage",
									"Cargo vans",
									"XL pickups"
								]
							},
							{
								title: "10x35+",
								numerics: ["350 sq ft", "2,800 cu ft & up"],
								bestFor: [
									"Recreational vehicles",
									"Boats",
									"Truck & trailer storage"
								]
							}
						]
					}
				}
			]
		},
		{
			title: "Vehicle Storage Costs",
			noPadding: true,
			modules: [
				{
					type: "size-chart",
					props: {
						title: "Understanding Vehicle Storage Costs",
						description:
							"Vehicle storage costs vary based on a number of factors, including seasonal demand, location, and additional amenities. Here's how average vehicle storage costs break down:",
						background: "light-blue",
						storages: [
							{
								title: "Outdoor Uncovered",
								numerics: ["$30-$100/Month"],
								bestFor: ["Budget option"]
							},
							{
								title: "Outdoor Covered",
								numerics: ["$75-$175/Month"],
								bestFor: ["Weather protection"]
							},
							{
								title: "Indoor Standard",
								numerics: ["$100-$250/Month"],
								bestFor: ["High level protection"]
							},
							{
								title: "Indoor Climate-Controlled",
								numerics: ["$150-$350/Month"],
								bestFor: ["Premium protection"]
							},
							{
								title: "Large Vehicle/RV",
								numerics: ["$100-$400+/Month"],
								bestFor: ["Large accommodations"]
							}
						]
					}
				}
			]
		},
		{
			title: "Vehicle Storage CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Vehicle",
						subheading: "Make a free reservation in minutes!",
						searchPlaceholder: "Search by city, state, or zip...",
						searchButtonText: "Find Storage",
						image: ctaMan,
						imageAltText: "Find vehicle storage",
						background: "white"
					}
				}
			]
		},
		{
			title: "Customer Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviewsContent
				}
			]
		},
		{
			title: "Vehicle Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Vehicle Storage FAQs",
						faqs
					}
				}
			]
		},
		{
			title: "Vehicle Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Vehicle Storage",
						unitCards: relatedContentCards,
						background: "light-blue"
					}
				}
			]
		},
		{
			title: "Links to Other PSPs",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						storageGridContent: pspLinksContent,
						background: "white"
					}
				}
			]
		},
		{
			title: "Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						storageType: "vehicle",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPVehicleContent;
